// extracted by mini-css-extract-plugin
export default {"quota":"quota--OozqC","status":"status--bUcHN","copyButton":"copyButton--uBYZC","empty":"empty--m5Fko"};